import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GatewayService } from '../gateway.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { WarningDialogComponent } from './warning-dialog/warning-dialog.component';
import { CpQrCodeService } from '../cp-portal/cp-qr-code/cp-qr-code.service';
import { NgxImageCompressService } from 'ngx-image-compress';
declare const APIGateway: any;

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  apiGateway: any;
  authJson: any = {};
  teamMemberList;
  saveImageInDatabaseArray: Array<any> = [];
  checkOS:boolean;
  private currentTimeStamp: any;
  appdata:any;
  constructor(private http: HttpClient,
    private router: Router, private snackBar: MatSnackBar, private gateway: GatewayService, public dialogRef: MatDialog, private cpQrCodeService: CpQrCodeService, public imageCompress: NgxImageCompressService) {
    this.apiGateway = new APIGateway().getEncryptionAPI();
    if( /iPhone|iPad|iPod|MacIntel|macOS|MacOS|macintosh|macppc|mac68k|macos|mac|Macintosh/i.test(navigator.userAgent) ) {
      this.checkOS = true;
     }
     else{
      this.checkOS = false;
     }
  }
  loaderStatus: Subject<any> = new BehaviorSubject(false);
  dmsResponse: Subject<any> = new BehaviorSubject(null);
  compressedFile: Subject<any> = new BehaviorSubject(null);
  docType: Subject<any> = new BehaviorSubject(null);
  index: Subject<any> = new BehaviorSubject(null);
  fileArray: Subject<any> = new BehaviorSubject(null);
  userType: Subject<any> = new BehaviorSubject(null);
  public docList = null;
  public mappingData = null;
  files: object;
  imageType: string;
  localUrl: string;
  filesToCompress = [];

  logout() {
    const body = {
      'LOGOUT': [{}]
    }
    return this.gateway.callApi(body, {});
  }

  logoutApplication() {
    this.showLoader();
    this.logout().subscribe(
      res => { },
      err => {
        if (err.status) {
          this.hideLoader();
          this.showError(
            err['data']['errorHint'] ? err['data']['errorHint'] : '',
            'success'
          );
          sessionStorage.removeItem('cpuserData');
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/cplogin']);
        }
      }
    );
  }

  public getDocomentsData(): Object {
    return this.docList;
  }
  public setDocomentsData(data): void {
    this.docList = data;
  }

  public setMappingData(data): void {
    this.mappingData = data;
  }

  public getMappingData(): Object {
    return this.mappingData;
  }

  public showLoader(): void {
    this.loaderStatus.next(true);
  }

  public hideLoader(): void {
    this.loaderStatus.next(false);
  }

  public getLoaderStatus() {
    return this.loaderStatus.asObservable();
  }

  public setAuthJsonData(data) {
    this.authJson = data;
  }

  public getAuthJsonData() {
    return this.authJson;
  }

  public setIndexdb(key: string, value: any) {
    return this.gateway.storeIndexDbApi(key, value).then(res => {
    }, error => {
    });
  }

  async getIndexdb(key: string) {
    const result = await this.gateway.getIndexDbApi(key);
    return result;
  }

  async clearIndexdb(key: string) {
    const result = await this.gateway.claerIndexDbApi(key);
    return result;
  }

  getData() {
    return JSON.parse(sessionStorage.getItem('cpuserData'));
  }

  public showError(message: string, result?: string): void {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    if (result && result === 'error')
      config.panelClass = 'red-snackbar';
    else if (result && result === 'success')
      config.panelClass = 'green-snackbar';
    this.snackBar.open(message, null, config);
  }

  public getErrors() {
    return {
      default: 'Something went wrong!',
      noData: 'No data found',
      decrypt: 'unable to decrypt data',
    }
  }


  public getOrgAppId(): string {
    if (environment['envProps']['orgId'] && environment['envProps']['appId']) {
      return (
        environment['envProps']['orgId'] + '-' + environment['envProps']['appId']
      );
    } else {
      console.error('Unable to get orgId and appId from environment.json');
    }
  }

  public pwcErrorHandle(err, show = true) {
    [
      `${this.getOrgAppId()}-pmlc`,
      `${this.getOrgAppId()}-regisFail`,
      `${this.getOrgAppId()}-Publickey`,
      `${this.getOrgAppId()}-jwtToken`,
      `${this.getOrgAppId()}-loginId`,
      `${this.getOrgAppId()}-authJwtToken`,
      `${this.getOrgAppId()}-forceLogin`,
      'userDetails',
      'lovVersion',
      'sbmLov'
    ].forEach(v => {
      this.clearIndexdb(v);
    });

    setTimeout(() => {
      this.router.navigate(['/auth/signin']);
    }, 500);
    if (show)
      this.showError(err.erroMessage ? err.erroMessage : 'It seems that service scope is configured as SECURE and service is called before login', 'error');
    return;
  }


  public getLocalStorage(key: string): string {
    const value = localStorage.getItem(key);
    if (value) {
      return this.apiGateway.aesEncryption.decryptText(value, 'decimalsecretkey');
    } else {
      this.showError(this.getErrors().decrypt);
      return null;
    }
  }

  public setLocalStorage(key: string, value: string): void {
    const data = this.apiGateway.aesEncryption.encryptText(value, 'decimalsecretkey');
    localStorage.setItem(key, data);
  }

  public warningResponseHandler() {
    this.showError('warning popup!!');
    const dialogRef = this.dialogRef.open(WarningDialogComponent, {
      maxWidth: 'inherit',
      width: '35vw',
      data: { message: 'Do You Want To Continue?', cancelButton: true }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  public handleError(err, data) {
    this.hideLoader();
    if (err.errorCode === 'PW-0002' || err.errorCode === 'PW-0004') {
      this.pwcErrorHandle(err)
    } else {
      if (data && data['errors']) {
        this.showError(data['errors'] ? data['errors']
          : this.getErrors().default, 'error');
      } else {
        this.showError(err['erroMessage'] ? err['erroMessage']
          : this.getErrors().default, 'error');
      }
    }
  }

  whatsappOptOut(mobileNumber: string, consent: string) {
    const body = {
      'USER_OPTOUT': [{
        'mobileNo': '91' + mobileNumber,
        'x_type': 'LP',
        'x_consent': consent,
        'x_process_remarks': 'success',
        'x_key_object_data': 1
      }]
    };
    return this.gateway.callApi(body, {});
  }

  public whatsappOptIn(mobileNumber: string, consent: string) {
    const body = {
      'USER_OPTIN': [{
        'mobileNo': '91' + mobileNumber,
        'x_type': 'LP',
        'x_consent': consent,
        'x_process_remarks': 'success',
        'x_key_object_data': 1
      }]
    };
    return this.gateway.callApi(body, {});
  }

  sp_get_cp_policy_grievance_dtls(req) {
    const body = {
      SPGETCPPOLICYGRIEVANCEDTLS: [{
        x_filter_property: req
      }]
    };
    return this.gateway.callApi(body, {});
  }

  downloadFile(req): any {
    return this.http.get(req, { responseType: 'blob' });
  }

  public shareQr(cpUserId, pdfFileIdArray) {
    this.showLoader();
    this.cpQrCodeService.sendQrEmail(cpUserId, pdfFileIdArray).subscribe(
      (res: any) => {
        this.hideLoader();
        if (res['SPSENDCPQREMAIL']['RESPONSE_CODE'] === 'I') {
          this.showError('QR has been shared successfully to ' + res['SPSENDCPQREMAIL']['EMAIL_ID'] + ' !', 'success');
        }
        else if (res['SPSENDCPQREMAIL']['RESPONSE_CODE'] === 'E') {
          this.showError('Email was not sent, please try again', 'error');
        }
      },
      (err: any) => {
        this.hideLoader();
        this.showError('Error in sending email', 'error');
      });
  }



  onFileSelect(event: any, imageType: any, indx?) {
    this.files = event.target.files;
    let docformat: any;
    this.imageType = imageType;
    if (this.fileValidation(event.target.files[0]) === 'true' && this.fileSize(event.target.files[0]) == "true") {
      docformat = event.target.files[0].type;
      if (event.target.files && event.target.files[0] && (docformat == 'image/png' ||
        docformat == 'image/jpeg' || docformat == 'image/jpg')) {
        const myFiles = Array.from(event.target.files);
        myFiles.forEach((file) => {
          const fileName = file['name'];
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.localUrl = event.target.result;
            this.compressFile(this.localUrl, fileName, docformat).then(d => {
              this.uploadImagesOnS3(this.filesToCompress, this.imageType, indx);
            });
          };
          reader.readAsDataURL(event.target.files[0]);
        });
      }
      else if (event.target.files && event.target.files[0] && imageType == 'gallery_docs' && (docformat == 'video/mp4' || docformat == 'video/mkv' || docformat == 'video/webm')) {
        this.filesToCompress = []
        let myVFiles = Array.from(event.target.files);
        myVFiles.forEach((file) => {
          this.filesToCompress.push(file)
          this.uploadImagesOnS3(this.filesToCompress, this.imageType, indx);
        });
      }
      else {
        this.showError('Invalid File format', 'error')
        this.hideLoader();
      }
    } else {
      this.showError('Invalid File format or Invalid size ', 'error');
      this.hideLoader();
    }
  }

  fileValidation(file) {
    const fileInput = file;
    const filePath = fileInput.name;
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.mp4|\.webm|\.mkv)$/i;
    if (!allowedExtensions.exec(filePath)) {
      fileInput.value = '';
      return 'false';
    } else {
      return 'true';
    }
  }

  compressFile(image, fileName, docformat, imageType?) {
    this.filesToCompress = []
    const orientation = -1;
    return this.imageCompress
      .compressFile(image, orientation, 50, 50)
      .then((result) => {
        const imageBlob = this.dataURItoBlob(result.split(',')[1], docformat);
        const imageFile = new File([imageBlob], fileName, {
          type: docformat,
        });
        this.filesToCompress.push(imageFile);
        if(imageType === 'qrImage') {
          this.compressedFile.next(this.filesToCompress);
        }
      })
      .catch((err) => {
      });
  }

  dataURItoBlob(dataURI, docformat) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: docformat });
    return blob;
  }

  fileSize(file){
    if(Math.ceil(file.size/1000000) <= 5){
      return "true"
    } else {
      return "false"
    }
  }
  uploadImagesOnS3(filesToCompress, imageType?, passwordObject?) {
    this.upload_Logo_PersonImageFileInDMS(this.filesToCompress, imageType, {}).subscribe(res => {
      // this.dmsResponse.next(res);
      this.dmsResponse.next({res:res,indx:passwordObject});
    });
  }

  uploadImageInDatabase(files, docType: any, passwordObject?) {
    this.showLoader();
    this.insert_Logo_ImageData(files, docType, {}).subscribe(res => {
      this.hideLoader();
      if (res['SPSSAMBINSERTAOFIMGDATA']['ISSUCCESSFUL'] === 'SUCCESS') {
        // success part goes here
      } else {
        this.showError(this.getErrors().default, 'error');
      }
    },
      err => {
        this.hideLoader();
        this.showError(this.getErrors().default, 'error');
      });
  }

  randomString(length = 10): any {
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    const randomNumber = crypto.getRandomValues(array);

    return randomNumber[0];
    // Math.round(
    //   Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)
    // )
    //   .toString()
    //   .slice(2, 12);
  }


  upload_Logo_PersonImageFileInDMS(files: any, docType: any, timePeriodDuration?: any) {
    const cpUserData = this.getData();
    timePeriodDuration['CPUSER_TYPE'] = cpUserData.CPUSER_TYPE;
    timePeriodDuration['CP_CODE'] = cpUserData.CP_CODE;
    timePeriodDuration['CP_USER_ID'] = cpUserData.CP_USER_ID;
    timePeriodDuration['CHANNEL_TYPE'] = cpUserData.CHANNEL_TYPE;

    const cp_code = cpUserData.CP_CODE == 0 ? 'CP0000' : cpUserData.CP_CODE;

    const currentDate = new Date();
    const mediaDataObject = [];
    files = Array.from(files);
    const body = new FormData();
    this.currentTimeStamp = currentDate.getTime();

    const commonData = {
      formId: 1,
      controlId: 1,
      fileDefId: 1,
      docId: '',
      docSubType: '',
      docBundleId: this.currentTimeStamp,
      expiryTime: 500000,

      customMetadata: timePeriodDuration ? timePeriodDuration : {},
      objectPriKey1: cp_code
        + currentDate.getTime() + this.randomString(),
      objectPriKey2: 'NA',
      objectPriKey3: 'NA',
      deviceCreateTimestamp: currentDate.toISOString().split('T')[0] + ' ' + currentDate.toTimeString().split(' ')[0],
      deviceModifyTimestamp: currentDate.toISOString().split('T')[0] + ' ' + currentDate.toTimeString().split(' ')[0],
      keepDeletedImage: 'Y',
      recSyncStatus: 'Y',
      recSyncTimestamp: currentDate.toISOString().split('T')[0] + ' ' + currentDate.toTimeString().split(' ')[0],
      deactivatedBy: '',
      documentError: '',
      status: 'ACTIVE',
      text1: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
    }
    files.forEach(file => {
      const object = {
        id: cp_code
          + currentDate.getTime() + this.randomString(),
        mediaDetails: {
          fileCaption: docType,
          fileMimeType: '',
          fileName: file['name'],
          fileType: file.type
        },
        docType: docType
      }

      const mediaDataIterations = Object.assign(object, commonData);
      mediaDataObject.push(mediaDataIterations);
      body.append('files', file);
    });

    body.append('mediaDataObjects', JSON.stringify(mediaDataObject));
    return this.gateway.callApiClientURLDms(body, cpUserData['LOGIN_ID']);
  }


  public insert_Logo_ImageData(filesArray, docType, timePeriodDuration) {
    this.saveImageInDatabaseArray = [];

    const currentDate = new Date();
    const dateAndTimeString = (currentDate).toISOString().split('T')[0] + ' ' + currentDate.toTimeString().split(' ')[0];
    const cpUserData = this.getData();
    timePeriodDuration['CPUSER_TYPE'] = cpUserData.CPUSER_TYPE;
    timePeriodDuration['CP_CODE'] = cpUserData.CP_CODE;
    timePeriodDuration['CP_USER_ID'] = cpUserData.CP_USER_ID;
    timePeriodDuration['CHANNEL_TYPE'] = cpUserData.CHANNEL_TYPE;

    const cp_code = cpUserData.CP_CODE === 0 ? 'CP0000' : cpUserData.CP_CODE;

    const commonBody = {
      'IMAGE_DFN_ID': '1',
      'VERSION_NO': '1',
      'FORM_ID': '1',
      'CONTROL_ID': '1',
      'FILE_TYPE': 'url',
      'DOC_ID': '1',
      'OBJECT_TYPE': '',
      'OBJECT_PRI_KEY_1': cp_code
        + currentDate.getTime() + this.randomString(),
      'OBJECT_PRI_KEY_2': 'NA',
      'OBJECT_PRI_KEY_3': 'NA',
      'LOGIN_ID': cpUserData.LOGIN_ID ? cpUserData.LOGIN_ID : 'NA',
      'DOC_TYPE': docType,
      'IS_ACTIVE': 'Y',
      'REC_SYNC_STATUS': 'W',
      'KEEP_DELETED_IMAGE': 'N',
      'MODIFICATION_NO': '0',
      'DOC_BUNDLE_ID': this.currentTimeStamp,
      'DEVICE_CREATE_TIMESTAMP': dateAndTimeString,
      'IMAGE_STREAM': '',
      'CUSTOM_METADATA': timePeriodDuration ? timePeriodDuration : '',
      'PW_SESSION_ID': this.randomString(),
      'LEAD_ERROR': '',
      'REC_SYNC_TIMESTAMP': '',
      'FILE_DELETED': '',
      'DEVICE_MODIFY_TIMESTAMP': dateAndTimeString
    };

    filesArray.forEach(key => {
      key.refId = cp_code
        + currentDate.getTime() + this.randomString()
        key.customMetadata = timePeriodDuration;

      const obj = {
        'FILE_PATH': JSON.stringify(key),
        'IMAGE_NAME': key['mediaDetails']['fileName'],
        'FILE_CAPTION': key['mediaDetails']['fileName']
      };
      const a = Object.assign(obj, commonBody);
      this.saveImageInDatabaseArray.push(a);
    });
    const body = {
      'SPSSAMBINSERTAOFIMGDATA':
        this.saveImageInDatabaseArray
    };
    return this.gateway.callApi(body, {});
  }

  getAllUserData(){
    const cpuserData = this.getData();
    const body = {
      "SPCPDASHBRDUSERHIERARCHY" : [{'x_login_id': cpuserData.MOBILE_NO }]
    }
    return this.gateway.callApi(body, {})
  }

  getTeamData() {
    this.getAllUserData().subscribe((usrdata: any) => {
      this.teamMemberList = (usrdata['SPCPDASHBRDUSERHIERARCHY'] && usrdata['SPCPDASHBRDUSERHIERARCHY']["object"] && usrdata['SPCPDASHBRDUSERHIERARCHY'] != null) ? JSON.parse(usrdata['SPCPDASHBRDUSERHIERARCHY'].object) : [];

      this.setLocalStorage("teamdata",JSON.stringify(this.teamMemberList));
    });
  }

  backnavigateToV1(){
    this.appdata =  JSON.parse(this.getLocalStorage('appdata'));
    if(this.appdata?.navigateTo === 'Dashboard' || this.appdata?.navigateTo === 'spList'){
      const cpUserData = this.getData();
      const queryParams = new URLSearchParams({
        appId: 'SAARATHI-0MY7TA7QRA',
        loginid: this.appdata['loginid'] || '',
        cpcode: cpUserData?.CP_CODE || '',
        view: 'epayout',
        dashboard: 'cp-dashboard'
      });
      window.location.href = `https://prod.saarathi.ai/mysaarathi-contract-dsa/#/?${queryParams.toString()}`;
      return;
    }
    if(this.appdata?.screen_name == 'saarathi_dash_cp_portal'){
      if(this.checkOS){
        const url = 'https://prod.saarathi.ai/mysaarathi-cp-portal/#/cpmarketing/cp-payment-summary/?loginid='+this.appdata['loginid']+'&navigateTo='+this.appdata['navigateTo']+'&screen_name=back_saarathi_dash_cp_portal';
          // window.open(url,'_blank')
        const save = document.createElement('a');
        save.href = url;
        // save.download = 'contract.pdf';
        save.setAttribute('target', '_blank');
        document.body.appendChild(save);
        save.click();
        document.body.removeChild(save);
        window.URL.revokeObjectURL(save.href);
        }
      else {
        this.router.navigate(['/cpmarketing/cp-payment-summary'],{queryParams:{loginid:this.appdata['loginid'],navigateTo:this.appdata['navigateTo'],screen_name:'back_saarathi_dash_cp_portal'}})
      }
    }
    else {
      if(this.checkOS){
        const url = 'https://prod.saarathi.ai/mysaarathi-cp-portal/#/cpmarketing/cp-payment-summary/?loginid='+this.appdata['loginid']+'&navigateTo='+this.appdata['navigateTo']+'&screen_name=back_saarathi_dash_sourcing_partner';
          // window.open(url,'_blank')
        const save = document.createElement('a');
        save.href = url;
        // save.download = 'contract.pdf';
        save.setAttribute('target', '_blank');
        document.body.appendChild(save);
        save.click();
        document.body.removeChild(save);
        window.URL.revokeObjectURL(save.href);
        }
      else {
        this.router.navigate(['/cpmarketing/cp-payment-summary'],{queryParams:{loginid:this.appdata['loginid'],navigateTo:this.appdata['navigateTo'],screen_name:'back_saarathi_dash_sourcing_partner'}})
      }
    }
  }

}
